import React, { useContext } from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { getLanguage } from "localization/i8intl";
import { useWindowSize } from "api/commonConstants";
// import Link from "next/link";
import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
// import Dropdown from "react-dropdown";
// import "react-dropdown/style.css";
import SearchableDropdown from "./SearchableDropdown";
import { useRouter } from "next/router";
// import getConfig from "next/config";
import ElectionsWidget from "components/elections-2023/ElectionsWidget";
import { MasterConfigContext } from "constants/MasterConfigContext";
import Tally from "components/tally/Tally";
import { stateData } from "constants/state";
// import { FormattedMessage } from "react-intl";
export default function KaunJeetaConsD({
  consId,
  state,
  stateHindi,
  consName,
  masterKey,
  cYear,
  ConstituencyListData2024,
  ConstituencyListData2019,
  constituencyArray,
  tabs,
  breadCrump,
  electionState,
  prevYear
}) {
  const electionsData = useContext(MasterConfigContext);
  const masterConfig = electionsData?.[masterKey];


  // const [currentYear, setCurrentYear] = useState(2020);
  const [currentYear, setCurrentYear] = useState(masterConfig?.electionYear_KJKH_detail);
  const displayYear = masterConfig?.displayYear
  const dryRun = masterConfig?.dryRun
  // const [currentYear, setCurrentYear] = useState(2019);

  // const [currentYear, setCurrentYear] = useState(${displayYear});
  const [restDataYear, setRestDataYear] = useState(prevYear[0]);
  // const [resultYearData, setResultYearData] = useState(
  //   restDataYear === 2019
  //     ? ConstituencyListData2019?.candidate
  //     : ConstituencyListData2019?.candidate_2014
  // );
  const [resultYearData, setResultYearData] = useState(
    ConstituencyListData2019?.[`candidate_${prevYear[0]}`]
  );

  const currentConstData = constituencyArray.filter((x) => x.cons_id == consId);
  console.log(
    "Cons page data ",
    ConstituencyListData2019,
    ConstituencyListData2024,
    constituencyArray
  );
  const placeName =
    consName.split("-").join(" ").slice(0, 1).toUpperCase() +
    consName.split("-").join(" ").slice(1);
  const stateName =
    state.split("-").join(" ").slice(0, 1).toUpperCase() +
    state.split("-").join(" ").slice(1);
  console.log("Currents statename", stateName, state);
  const [language, setLanguage] = useState("");
  const size = useWindowSize();
  const router = useRouter();
  useEffect(() => {
    setLanguage(getLanguage());
  }, []);
  useEffect(() => {
    setLanguage(getLanguage());
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_ATF_728x90",
              [
                [728, 90],
                [970, 250],
                [970, 90],
              ],
              "div-gpt-ad-1701945163318-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
              [728, 90],
              "div-gpt-ad-1701945220410-1"
            )
            .addService(googletag.pubads());

          //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");

          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_ATF_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-1"
            )
            .addService(googletag.pubads());
            googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_HP_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1701946324333-0"
            )
            .addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      }
      googletag.pubads().refresh();
      // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [

      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []);
  // const [prevData, setPrevData] = useState([]);
  const constituencyId = consId;
  const website = "llt";
  const colorOptions = {
    llt: "#eb0e8c",
    tg: "#d9368b",
    mz: "#8ab3dc",
    mp: "#0c8a70",
    cg: "#2d8468",
    llt: "#d9368b",
    rj: "#fed029",
    up: "#f6523e",
    gj: "#f362b3",
    ct: "#B71F33",
    mt: "#f92929",
  };


  useEffect(() => {
    const data = ConstituencyListData2019?.[`candidate_${restDataYear}`]

    if (data.length > 0) {
      setResultYearData(data);
    }
    else {
      setResultYearData([]);
    }

  }, [restDataYear]);
  // useEffect(() => {
  //   const temp = ConstituencyListData2019?.[`candidate_${restDataYear}`]
  //   debugger
  //   if (restDataYear === 2019) {
  //     setResultYearData(ConstituencyListData2019?.[`candidate_${restDataYear}`]);
  //   } else if (restDataYear === 2014) {
  //     setResultYearData(ConstituencyListData2019?.[`candidate_${restDataYear}`]);
  //   } else if (restDataYear === ${displayYear}) {
  //     setResultYearData(ConstituencyListData2024?.candidate);
  //   } else {
  //     setResultYearData([]);
  //   }

  // }, [restDataYear]);
  const mainUrl = "all";
  const consNameCamel = consName.charAt(0).toUpperCase() + consName.slice(1);
  return (
    <>
      <Head>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org/",
              "@type": "WebPage",
              name: `${consNameCamel} Assembly Election ${displayYear}:  ${consNameCamel} Election Candidates List,  ${consNameCamel} Results,  ${consNameCamel} Chunav Results`,
              description: `${consNameCamel} Assembly Chunav ${displayYear} (${consNameCamel} विधानसभा चुनाव ${displayYear}): Find here ${consNameCamel} Assembly Election party-wise candidate list, winner, runner-up list, live election result updates (constituency name), photos, videos and news in hindi`,
              keywords: `${consNameCamel} elections ${displayYear},
          ${consNameCamel} assembly elections ${displayYear},
          ${consNameCamel} assembly elections results ${displayYear},
          ${consNameCamel} assembly elections ${displayYear} results,
          ${consNameCamel} assembly election live results`,
              url: `https://www.thelallantop.com${router.asPath}`,
              publisher: {
                "@type": "Organization",
                name: "The Lallantop",
                url: "https://www.thelallantop.com/",
                logo: {
                  "@type": "ImageObject",
                  url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                  width: 600,
                  height: 60,
                },
              },
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  item: {
                    "@id": `${process.env.NEXT_PUBLIC_BASE_URL}`,
                    name: `Home`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  item: {
                    name: `Election`,
                    "@id": `${process.env.NEXT_PUBLIC_BASE_URL}/election`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  item: {
                    name: `${state} Election Results`,
                    "@id": `${process.env.NEXT_PUBLIC_BASE_URL
                      }/election/${state.toLowerCase()}-assembly-chunav`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 4,
                  item: {
                    name: `${consName} Election Results`,
                    "@id": `${process.env.NEXT_PUBLIC_BASE_URL}${router.asPath}`,
                  },
                },
              ],
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "SiteNavigationElement",
              name: [
                "होम",
                "चुनाव",
                "न्यूज़",
                "एंटरटेनमेंट",
                "ऑडनारी",
                "टेक्नोलॉजी",
                "पड़ताल",
                "बिज़नेस",
                "लल्लनख़ास",
                "स्पोर्ट्स",
                "रंगरूट",
              ],
              url: [
                "https://www.thelallantop.com/",
                "https://www.thelallantop.com/election",
                "https://www.thelallantop.com/news",
                "https://www.thelallantop.com/entertainment",
                "https://www.thelallantop.com/oddnaari",
                "https://www.thelallantop.com/technology",
                "https://www.thelallantop.com/factcheck",
                "https://www.thelallantop.com/business",
                "https://www.thelallantop.com/lallankhas",
                "https://www.thelallantop.com/sports",
                "https://www.thelallantop.com/education",
              ],
            }),
          }}
        ></script>
        <link
          rel="preconnect"
          crossOrigin="true"
          href="https://static.chartbeat.com"
        ></link>

        <script
          async
          dangerouslySetInnerHTML={{
            __html: `
            (function () {
              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
              _sf_async_config.uid = 60355;
              _sf_async_config.domain = 'thelallantop.com';
              _sf_async_config.useCanonical = true;
              _sf_async_config.useCanonicalDomain = true;
              _sf_async_config.sections = 'home'; 
              _sf_async_config.authors = '';
              function loadChartbeat() {
                  var e = document.createElement('script');
                  var n = document.getElementsByTagName('script')[0];
                  e.type = 'text/javascript';
                  e.async = true;
                  e.src = '//static.chartbeat.com/js/chartbeat.js';
                  n.parentNode.insertBefore(e, n);
              }
              loadChartbeat();
          })();
       `,
          }}
          strategy="afterInteractive"
          id="chartbeat"
          type="text/javascript"
        ></script>
      </Head>
      <NextSeo
        title={`${consNameCamel} Assembly Election ${displayYear}:  ${consNameCamel} Election Candidates List,  ${consNameCamel} Results,  ${consNameCamel} Chunav Results`}
        description={`${consNameCamel} Assembly Chunav ${displayYear} (${consNameCamel} विधानसभा चुनाव ${displayYear}): Find here ${consNameCamel} Assembly Election party-wise candidate list, winner, runner-up list, live election result updates (constituency name), photos, videos and news in hindi`}
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}${router.asPath}`}
      />
      <meta
        name="keywords"
        content={`${consNameCamel} elections ${displayYear},
          ${consNameCamel} assembly elections ${displayYear},
          ${consNameCamel} assembly elections results ${displayYear},
          ${consNameCamel} assembly elections ${displayYear} results,
          ${consNameCamel} assembly election live results`}
      />
      {size.width > 600 ? (
        <div>
          {size.width >= 600 && (
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {router.asPath.includes("election") && (
                <div style={{ position: "relative" }}>
                  <img
                    src={"/assets/images/election-background-3.png"}
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "298px",
                    }}
                  ></img>
                  <img
                    src="/assets/images/left-election-top-2.png"
                    width=""
                    height="170px"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                    }}
                  ></img>
                  <img
                    src={
                      router.asPath.includes("haryana-assembly")
                        ? "/assets/images/right-election-top-2.png"
                        : router.asPath.includes("jammu-kashmir-assembly")
                          ? "/assets/images/jammu-kashmir.png"
                          : "/assets/images/indian-map.png"
                    }
                    width=""
                    height="250px"
                    style={{ position: "absolute", bottom: "0", right: "0px" }}
                  ></img>
                </div>
              )}
              <Container
                align="center"
                style={{
                  position: router.asPath.includes("/election")
                    ? "absolute"
                    : "relative",
                  top: router.asPath.includes("/election") ? "22px" : "0px",
                }}
              >
                {/* <Ads
         adName={"/1007232/Lallantop_ROS_728x90_300x250"}
         keyBindings={{
           category: [router.query?.categoryName],
           keywords: metaTags[category]?.metaKeyword,
         }}
       /> */}

                <div className="container-row py-2" align="center">
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#b7b7b7",
                      textAlign: "center",
                      marginBottom: "0px",
                    }}
                  >
                    Advertisement
                  </p>
                  <div
                    id="div-gpt-ad-1701945163318-0"
                    style={{
                      minWidth: "300px",
                      minHeight: "100px",
                      display: "block !important",
                      alignContent: "center",
                      textAlign: "-webkit-center",
                    }}
                    className="ads-auto-resize"
                  >
                    <script
                      type="text/javascript"
                      dangerouslySetInnerHTML={{
                        __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})`,
                      }}
                    ></script>
                  </div>
                </div>
              </Container>
            </div>
          )}
        </div>
      ) : (
        <div style={{ position: "relative", width: "100%" }}>
          <img
            src={"/assets/images/election-background-mobile.png"}
            style={{ position: "relative", width: "100%", height: "auto" }}
          ></img>
          <img
            src="/assets/images/election-left-mobile.png"
            width=""
            height="70px"
            style={{ position: "absolute", bottom: "10px", left: "10px" }}
          ></img>
          <img
            src={
              router.asPath.includes("haryana-assembly")
                ? "/assets/images/right-election-top-2.png"
                : router.asPath.includes("jammu-kashmir-assembly")
                  ? "/assets/images/jammu-kashmir.png"
                  : "/assets/images/indian-map.png"
            }
            width=""
            height="90px"
            style={{ position: "absolute", bottom: "0", right: "0px" }}
          ></img>
        </div>
      )}

      {/* desktop bread crump  */}
      {size.width > 768 ?
        (
          <>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                width: "max-content",
                margin: "auto",
                gap: "68px",
                height: "80px",
                marginTop: "15px",
                borderRadius: "12px",
                padding: "0px 30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  // paddingTop: "1rem",
                  gap: "8px",
                  // cursor: "pointer",
                  backgroundColor: "white",
                  paddingLeft: "0px",
                }}
              // onClick={() =>
              //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
              // }
              >
                {/* <div
              style={{ fontSize: "35px", fontWeight: "700", color: "white" }}
            >
              चुनाव
            </div> */}
                <img
                  src="/assets/images/assembly-chunav.png"
                  width="408.56px"
                  height="58.21px"
                  style={{ alignSelf: "center" }}
                ></img>
              </div>
              <div
                class="divCategoriesSchedule2 snipcss-eqdpv"
                style={{
                  margin: "0px 0px",
                  // backgroundColor: "rgb(217, 54, 139)",
                  paddingLeft: "15px",
                  alignContent: "center",
                  // display : "flex",
                  // justifyContent : "center"
                }}
              >


                {/* dynamic breadcrump  */}
                {breadCrump.length > 0 &&

                  breadCrump.map((item, index) => {
                    return masterConfig[item.keyToShow] != false ? <a key={index} href={item.url}>
                      <span>{item.displayText}</span>
                    </a> : null
                  })


                }

              </div>
            </div>

          </>
        )
        :

        (

          // mobile breadcrump 
          <>

            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "1rem",
                  gap: "8px",
                  // cursor: "pointer",
                  paddingBottom: "1rem",
                  backgroundColor: "white",
                  marginTop: "10px",
                }}
              // onClick={() =>
              //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
              // }
              >
                <img
                  src="/assets/images/assembly-chunav.png"
                  width="240px"
                  height="auto"
                  style={{ alignSelf: "center" }}
                ></img>
              </div>
              <div
                class="divCategoriesSchedule2 snipcss-eqdpv"
                style={{
                  margin: "-1px 0px",
                  backgroundColor: "white",
                  paddingLeft: "15px",
                  paddingBottom: "1rem",
                  display: "flex",
                  justifyContent: ""
                }}
              >


                {/* dynamic breadcrump  */}
                {breadCrump.length > 0 &&

                  // breadCrump.map(item => {
                  //   return <a href={item.url}>
                  //   <span>{item.displayText}</span>
                  // </a>
                  // })
                  breadCrump.map((item, index) => {
                    return masterConfig[item.keyToShow] != false ? <a key={index} href={item.url}>
                      <span>{item.displayText}</span>
                    </a> : null
                  })


                }

              </div>
            </div>

          </>
        )}
      <br></br>

      {size.width <= 768 && (
            <div className="container-row py-2" align="center">
              <p
                style={{
                  fontSize: "11px",
                  color: "#b7b7b7",
                  textAlign: "center",
                  marginBottom: "0px",
                }}
              >
                Advertisement
              </p>
              <div
                id="div-gpt-ad-1701946028239-0"
                style={{
                  minWidth: "300px",
                  minHeight: "260px",
                  maxHeight: "265px",
                  display: "block !important",
                  alignContent: "center",
                  textAlign: "-webkit-center",
                }}
                className="ads-auto-resize"
              >
                <script
                  type="text/javascript"
                  dangerouslySetInnerHTML={{
                    __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})`,
                  }}
                ></script>
              </div>
            </div>
          )}
      <Tally stateName={stateData[electionState].tallyState} masterConfig={masterConfig} />

      {/* {masterConfig?.HRExittally && (
        <>
          {size.width < 768 ? (
            <div className="result-page">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा एग्ज़िट पोल
              </h2>
              <div>
                <iframe
                  src={`${masterConfig?.HRExittally_URL}`}
                  width="100%"
                  height={masterConfig?.Exitpolltally_height_mobile}
                ></iframe>
              </div>
            </div>
          ) : 
          (
            <div className="result-page">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा एग्ज़िट पोल
              </h2>
              <div>
                <iframe
                  src={`${electionsData?.vidhansabha_election.HRExittally_URL}`}
                  width="100%"
                  height={
                    electionsData?.vidhansabha_election
                      .Exitpolltally_height_web
                  }
                ></iframe>
              </div>
            </div>
          )}
        </>
      )}
      {masterConfig?.HRresulttally && (
        <>
          {size.width < 768 ? (
            <div className="result-page-big">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा रिजल्ट
              </h2>
              <div>
                <iframe
                  src={masterConfig?.HRresulttally_URL}
                  width="100%"
                  height={masterConfig?.Resulttally_height_mobile}
                ></iframe>
              </div>
            </div>
          ) : (
            <div className="result-page-big">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा रिजल्ट
              </h2>
              <div>
                <iframe
                  src={masterConfig?.HRresulttally_URL}
                  width="100%"
                  height={masterConfig?.Resulttally_height_web}
                ></iframe>
              </div>
            </div>
          )}
        </>
      )} */}

      <ul
        className="breadcrumb assembly-breadcrumb"
        style={{ margin: "auto", marginBottom: "20px" }}
      >
        <li>
          <a href="/" passHref>
            <a
              aria-label="Lallantop Home"
              style={{ display: "flex", marginTop: "2px" }}
            >
              <i className="icon-cat-home"></i>
              <span>Home</span>
            </a>
          </a>
        </li>
        <li>
          <a href="/election" passHref>
            <a aria-label="Lallantop Home">
              <span>Election</span>
            </a>
          </a>
        </li>
        {/* <li>
            <a href={`/election/${stateName === "Haryana" ? "haryana" : "jammu-kashmir"}-assembly-chunav/results`} passHref>
              <a aria-label="Lallantop Home">
                <span>
                 Results
                </span>
              </a>
            </a>
          </li> */}
        <li>
          <a
            href={`/election/${electionState
              }/results`}
            passHref
          >
            <a aria-label="Lallantop Home">
              <span>{stateName} Election Results</span>
            </a>
          </a>
        </li>
        {
          <li>
            <span> {placeName} Election Results</span>
          </li>
        }
      </ul>
      <ElectionsWidget />
      <div className="lok-sabha-main" style={{ background: "white" }}>
        <div className="result-page">
          <h1>{` ${currentConstData[0]?.cons_name_hi} विधानसभा चुनाव ${displayYear} (${currentConstData[0]?.cons_name} Assembly Election)`}</h1>
          {currentYear != cYear ? (
            <div style={{ fontSize: "18px" }}>
              {router.query.electionState.includes("delhi-assembly-chunav") ? (
                `दिल्ली की ${currentConstData[0]?.cons_name_hi
                } (${currentConstData[0]?.cons_name}) विधानसभा सीट पर कौन चल रहा है आगे? तीसरे नंबर पर कौन सा उम्मीदवार है? या कोई निर्दलीय बिगाड़ रहा है खेल? इस सीट का पूरा लेखा-जोखा जानिए बस एक क्लिक में। एक-एक राउंड की सबसे तेज और सटीक जानकारी सिर्फ दी लल्लनटॉप पर।`
              ) : (
                `2019 के विधानसभा चुनाव में ${currentConstData[0]?.cons_name_hi
                } (${currentConstData[0]?.cons_name}) सीट से कौन जीता और कौन हारा? 
  तीसरे नंबर पर कौन सी पार्टी थी या फिर निर्दलीय? 2014 में ${currentConstData[0]?.cons_name_hi
                } सीट पर किसके बीच मुकाबला था और किसके सिर जीत का सेहरा बंधा था? 
  सारी जानकारी आपकी सीट के हिसाब से। बस सेलेक्ट करें और सारी जानकारी आपकी स्क्रीन पर। 
  ${displayYear} के विधानसभा चुनाव की हर सीट का रिजल्ट भी आपको यहीं मिलेगा, सिर्फ दी लल्लनटॉप पर।`
              )}

            </div>
          ) : (
            <div>
              {stateHindi} की{" "}
              {currentConstData[0]?.cons_name_hi} विधानसभा सीट पर कौन चल रहा है
              आगे? तीसरे नंबर पर है कौन सा उम्मीदवार? या कोई निर्दलीय बिगाड़ रहा
              है खेल? इस सीट का पूरा लेखा जोखा जानिए बस एक क्लिक में. एक-एक
              राउंड की सबसे तेज और सटीक जानकारी सिर्फ दी लल्लनटॉप पर.
            </div>
          )}
         
          <br />
          <h2
            className="winner-box-header"
            style={{
              fontSize: "22px",
              fontWeight: "700",
              borderColor: colorOptions["llt"],
            }}
          >
            विधानसभा चुनाव ({currentConstData[0]?.cons_name_hi})
          </h2>
          <div className="assembly-buttons">


            {tabs.map(item => {
              return masterConfig?.[item.keyToShow] != false ? <div
                onClick={() => {

                  window.location.href =
                    item.url;

                }}
                className={
                  item.showActive
                    ? "assembly-buttons-btn-active"
                    : "assembly-buttons-btn"
                }
              >
                {item.text}
              </div> : null
            })}
            {/* <div
              onClick={() => {
                if (stateName !== "Haryana") {
                  window.location.href =
                    "/election/haryana-assembly-chunav/results";
                }
              }}
              className={
                stateName === "Haryana"
                  ? "assembly-buttons-btn-active"
                  : "assembly-buttons-btn"
              }
            >
              हरियाणा
            </div> */}
            {/* {masterConfig?.JKresultpage && (
              <div
                onClick={() => {
                  if (stateName !== "Jammu and Kashmir") {
                    window.location.href =
                      "/election/jammu-kashmir-assembly-chunav/results";
                  }
                }}
                className={
                  stateName === "Jammu kashmir"
                    ? "assembly-buttons-btn-active"
                    : "assembly-buttons-btn"
                }
              >
                जम्मू कश्मीर
              </div>
            )} */}
          </div>
          {currentYear == cYear ? (
            <ResponsiveCard
              constituencyListData={ConstituencyListData2024}
              selectedConstituencyId={constituencyId}
              colorCode={colorOptions[website]}
              constId={constituencyId}
              constituencyArray={constituencyArray}
              t={'t'}
              electionState={electionState}


            />
          ) : (
            <ResponsiveCard
              constituencyListData={ConstituencyListData2019}
              selectedConstituencyId={constituencyId}
              colorCode={colorOptions[website]}
              constId={constituencyId}
              constituencyArray={constituencyArray}
              t={'b'}
              electionState={electionState}

            />
          )}
          <div>
            {console.log(
              "Checking both data",
              ConstituencyListData2019,
              ConstituencyListData2024
            )}
            <br></br>
            {/* This is for testing purpose of 2014 candidates */}
            {ConstituencyListData2024?.candidate?.length > 0 &&
              currentYear == cYear && (
                <div className="winners-list-box">
                  <h3
                    className="winner-box-header"
                    style={{
                      letterSpacing: "normal",
                      borderColor: colorOptions["llt"],
                    }}
                  >
                    चुनाव {currentYear} के उम्मीदवार
                  </h3>
                  {ConstituencyListData2024?.candidate?.length > 0 &&
                    ConstituencyListData2024?.candidate[0]?.status ===
                    "WON" && dryRun == true && (
                      <div className="winner-box">
                        <div className="winner-box-heading">
                          <div
                            style={{ alignSelf: "center", fontSize: "20px" }}
                          >
                            विजेता
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <div
                            // add link here
                            onClick={() =>{

                              masterConfig.Show_Candidate_Profile ?
                              window.open(
                                `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                                  electionState
                                }/candidate-${(
                                  ConstituencyListData2024?.candidate[0]
                                  ?.candidate
                                )
     
                                  ?.toLowerCase()
                                  .replace(/[^a-zA-Z ]/g, "")
                                  .split(" ")
                                  .join("-")}-${ConstituencyListData2024?.candidate[0]?.id}-${
                                  consId}`,
                                "_self"
                              ) : ""
                            }
                            }
                            style={masterConfig?.Show_Candidate_Profile ? {
                              // textAlign: "center",
                              cursor: "pointer",
                              textDecoration: "underline",
                              fontSize: "18px" ,
                              
                            }    :   { fontSize: "18px" }}>
                              {ConstituencyListData2024?.candidate &&
                                ConstituencyListData2024?.candidate[0]
                                  ?.candidate}
                              {", "}
                              {ConstituencyListData2024?.candidate &&
                                ConstituencyListData2024?.candidate[0]?.party}
                            </div>
                            <img
                              width="40px"
                              height="40px"
                              src={
                                ConstituencyListData2024?.candidate &&
                                ConstituencyListData2024?.candidate[0]
                                  ?.party_logo
                              }
                            ></img>
                          </div>
                        </div>
                        <div className="winner-box-heading-2">
                          <div style={{ alignSelf: "center" }}>वोट</div>
                          <div
                            style={{ fontSize: "18px", alignSelf: "center" }}
                          >
                            {ConstituencyListData2024?.candidate &&
                              ConstituencyListData2024?.candidate[0]?.votes}
                          </div>
                        </div>
                        {/* <div className="winner-box-heading-2">
                          <div style={{ alignSelf: "center" }}>
                            विजेता पार्टी का वोट %
                          </div>
                          <div
                            style={{ fontSize: "18px", alignSelf: "center" }}
                          >
                            {ConstituencyListData2024?.candidate &&
                              ConstituencyListData2024?.candidate[0]
                                ?.percentage_votes}{" "}
                            %
                          </div>
                        </div> */}
                        {/* <div
                          className="winner-box-heading-2"
                          style={{
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          {console.log(
                            "percent data ",
                            ConstituencyListData2024?.candidate
                          )}
                          <div style={{ alignSelf: "center" }}>जीत अंतर %</div>
                          <div
                            style={{ fontSize: "18px", alignSelf: "center" }}
                          >
                            {ConstituencyListData2024?.candidate &&
                              ConstituencyListData2024?.candidate[0]
                                ?.winning_percentage}{" "}
                            %
                          </div>
                        </div> */}
                      </div>
                    )}
                  <br></br>
                  <table>
                    <th
                      style={{
                        background: colorOptions[website],
                        textAlign: "left",
                      }}
                    >
                      नाम
                    </th>
                    <th style={{ background: colorOptions[website] }}>
                      पार्टी
                    </th>
                    <th style={{ background: colorOptions[website] }}>वोट</th>

                    {masterConfig?.isElectionAlpha == true &&
                      ConstituencyListData2024?.candidate.map(
                        (candidate, index) => {
                          return (
                            <>
                              {size.width < 768 ? 
                              (
                                <tr
                                  key={candidate?.ac_no}
                                  className={index % 2 !== 0 ? "oddColor" : ""}
                                // onClick={() =>
                                //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                                // }
                                >
                                  <td

                                    //add link here
                                    onClick={() =>{

                                      masterConfig.Show_Candidate_Profile && candidate?.candidate != 'NOTA' ?
                                      window.open(
                                        `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                                          electionState
                                        }/candidate-${(
                                          candidate?.candidate
                                        )
             
                                          ?.toLowerCase()
                                          .replace(/[^a-zA-Z ]/g, "")
                                          .split(" ")
                                          .join("-")}-${candidate?.id}-${
                                          consId}`,
                                        "_self"
                                      ) : ""
                                    }
                                    }
                                    style={masterConfig?.Show_Candidate_Profile  && candidate?.candidate != 'NOTA'? {
                                      // textAlign: "center",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                      fontSize: "18px" ,
                                      
                                    }    :   { fontSize: "18px" }}
                                    className="candidate_name"
                                  >
                                    {candidate?.candidate}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "16px",
                                      // display:"flex",
                                      // gap:"15px",
                                      // paddingLeft:"5%"
                                      textAlign: "center",
                                    }}
                                    className="candidate_name"
                                  >
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        style={{ borderRadius: "100%" }}
                                        src={candidate?.party_logo}
                                      ></img>
                                    </div>
                                    <div>{candidate?.party}</div>
                                  </td>
                                  <td
                                    className="winner-name"
                                    style={{
                                      textAlign: "center",
                                      borderLeftColor: "#d2d1d1",
                                      borderLeftWidth: "0.2px",
                                    }}
                                  >
                                    {candidate?.win_loss ===
                                      "Result Awaited" ? (
                                      "Result Awaited"
                                    ) : dryRun == true ?
                                      (
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "10px",
                                            margin: "auto",
                                            width: "auto",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <p
                                            style={{
                                              margin: "0",
                                              fontSize: "16px",
                                            }}
                                          >
                                            {candidate?.votes}
                                          </p>{" "}
                                          {candidate?.status_logo && (
                                            <img
                                              src={candidate?.status_logo}
                                              width="20px"
                                              height="20px"
                                            ></img>
                                          )}
                                        </div>
                                      ) : "Result Awaited"
                                    }
                                  </td>
                                </tr>
                              ) : 
                              (
                                <tr
                                  key={candidate?.ac_no}
                                  className={index % 2 !== 0 ? "oddColor" : ""}
                                // onClick={() =>
                                //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                                // }
                                >
                                  <td

                                    //add link here
                                    onClick={() =>{

                                      masterConfig.Show_Candidate_Profile && candidate?.candidate != 'NOTA' ?
                                      window.open(
                                        `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                                          electionState
                                        }/candidate-${(
                                          candidate?.candidate
                                        )
             
                                          ?.toLowerCase()
                                          .replace(/[^a-zA-Z ]/g, "")
                                          .split(" ")
                                          .join("-")}-${candidate?.id}-${
                                          consId}`,
                                        "_self"
                                      ) : ""
                                    }
                                    }
                                    style={masterConfig?.Show_Candidate_Profile && candidate?.candidate != 'NOTA' ? {
                                      // textAlign: "center",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                      fontSize: "18px" ,
                                      
                                    }    :   { fontSize: "18px" ,}}
                                    className="candidate_name"
                                  >
                                    {candidate?.candidate}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "19px",
                                      // display:"flex",
                                      // gap:"15px",
                                      paddingLeft: "5%",
                                    }}
                                    className="candidate_name"
                                  >
                                    <img
                                      width="25px"
                                      height="25px"
                                      style={{
                                        borderRadius: "100%",
                                        marginRight: "10px",
                                      }}
                                      src={candidate?.party_logo}
                                    ></img>
                                    {candidate?.party}
                                  </td>
                                  <td
                                    className="winner-name"
                                    style={{
                                      textAlign: "center",
                                      borderLeftColor: "#d2d1d1",
                                      borderLeftWidth: "0.2px",
                                    }}
                                  >
                                    {candidate?.win_loss ===
                                      "Result Awaited" ? (
                                      "Result Awaited"
                                    ) : dryRun == true ?
                                      (
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "10px",
                                            margin: "auto",
                                            width: "auto",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <p
                                            style={{
                                              margin: "0",
                                              fontSize: "18px",
                                            }}
                                          >
                                            {candidate?.votes}
                                          </p>{" "}
                                          {candidate?.status_logo && (
                                            <img
                                              src={candidate?.status_logo}
                                              width="20px"
                                              height="20px"
                                            ></img>
                                          )}
                                        </div>
                                      ) : "Result Awaited"}
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        }
                      )}
                  </table>
                </div>
              )}
            <br></br>
            {(ConstituencyListData2019?.candidate_2019?.length > 0 ||
              ConstituencyListData2019?.candidate_2014?.length > 0) && (
                <div
                  className="winner-box-header"
                  style={{ borderColor: colorOptions[website] }}
                >
                  उम्मीदवार
                </div>
              )}
            <br></br>

            <div className="winner-box-years">
              {/* {ConstituencyListData2024?.candidate?.length > 0 && currentYear === ${displayYear} && (
                <button
                  className={`${currentYear !== ${displayYear} ? "btn-disable" : ""}`}
                  onClick={() => setCurrentYear(${displayYear})}
                  style={{ backgroundColor: colorOptions[website] }}
                >
                  ${displayYear}
                </button>
              )} */}
              {ConstituencyListData2019?.[`candidate_${prevYear[0]}`]?.length > 0 && (
                <button
                  className={`${restDataYear != prevYear[0] ? "btn-disable" : ""}`}
                  onClick={() => setRestDataYear(prevYear[0])}
                  style={{ backgroundColor: colorOptions[website] }}
                >
                  {prevYear[0]}
                </button>
              )}
              {ConstituencyListData2019?.[`candidate_${prevYear[1]}`]?.length > 0 && (
                <button
                  className={`${restDataYear != prevYear[1] ? "btn-disable" : ""}`}
                  onClick={() => setRestDataYear(prevYear[1])}
                  style={{ backgroundColor: colorOptions[website] }}
                >
                  {prevYear[1]}
                </button>
              )}
            </div>
            {ConstituencyListData2019?.[`candidate_${restDataYear}`]?.length > 0 && (
              <div className="winner-box">
                <div className="winner-box-heading">
                  <div style={{ alignSelf: "center", fontSize: "20px" }}>
                    विजेता
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div style={{ fontSize: "18px" }}>
                      {resultYearData && resultYearData[0]?.candidate}
                      {", "}
                      {resultYearData && resultYearData[0]?.party}
                    </div>
                    <img
                      width="40px"
                      height="40px"
                      src={resultYearData && resultYearData[0]?.party_logo}
                    ></img>
                  </div>
                </div>
                <div className="winner-box-heading-2">
                  <div style={{ alignSelf: "center" }}>वोट</div>
                  <div style={{ fontSize: "18px", alignSelf: "center" }}>
                    {resultYearData && resultYearData[0]?.votes}
                  </div>
                </div>
                <div className="winner-box-heading-2">
                  <div style={{ alignSelf: "center" }}>
                    विजेता पार्टी का वोट %
                  </div>
                  <div style={{ fontSize: "18px", alignSelf: "center" }}>
                    {resultYearData && resultYearData[0]?.percentage_votes} %
                  </div>
                </div>
                <div
                  className="winner-box-heading-2"
                  style={{
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                  }}
                >
                  <div style={{ alignSelf: "center" }}>जीत अंतर %</div>
                  <div style={{ fontSize: "18px", alignSelf: "center" }}>
                    {resultYearData && resultYearData[0]?.winning_percentage} %
                  </div>
                </div>
              </div>
            )}
          </div>
          <br></br>
          {ConstituencyListData2019?.[`candidate_${restDataYear}`]?.length > 0 && (
            <div className="winners-list-box">
              <div
                className="winner-box-header"
                style={{ borderColor: colorOptions[website] }}
              >
                अन्य उम्मीदवार
              </div>
              <br></br>
              <div>
                <table class="overflow-hidden">
                  <th
                    style={{
                      backgroundColor: colorOptions[website],
                      textAlign: "center",
                    }}
                  >
                    नाम
                  </th>
                  <th
                    style={{
                      backgroundColor: colorOptions[website],
                      textAlign: "center",
                      borderLeftColor: "white",
                      borderLeftWidth: "1px",
                    }}
                  >
                    पार्टी
                  </th>
                  <th
                    style={{
                      backgroundColor: colorOptions[website],
                      textAlign: "center",
                      borderLeftColor: "white",
                      borderLeftWidth: "1px",
                    }}
                  >
                    वोट
                  </th>
                  {ConstituencyListData2019 &&
                    resultYearData?.slice(1).map((con, index) => {
                      return (
                        <>
                          {size.width < 768 ? (
                            <tr
                              key={index}
                              className={index % 2 !== 0 ? "oddColor" : ""}
                            // style={{ cursor: "pointer" }}
                            // onClick={() =>
                            //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                            // }
                            >
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "16px",
                                }}
                              >
                                {con?.candidate}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  color: con?.colorCode,
                                  borderLeftColor: "#d2d1d1",
                                  borderLeftWidth: "0.2px",
                                  fontSize: "16px",
                                }}
                              >
                                <div>
                                  <img
                                    src={con?.party_logo}
                                    width="20px"
                                    height="20px"
                                    style={{ borderRadius: "50%" }}
                                  ></img>
                                </div>
                                <div>{con?.party}</div>
                              </td>
                              <td
                                className="winner-name"
                                style={{
                                  textAlign: "center",
                                  borderLeftColor: "#d2d1d1",
                                  borderLeftWidth: "0.2px",
                                  fontSize: "16px",
                                }}
                              >
                                {con?.votes}
                              </td>
                            </tr>
                          ) : (
                            <tr
                              key={index}
                              className={index % 2 !== 0 ? "oddColor" : ""}
                            // style={{ cursor: "pointer" }}
                            // onClick={() =>
                            //   (window.location = `/elections/constituency-list-2019/${con?.ac_no}`)
                            // }
                            >
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "18px",
                                }}
                              >
                                {con?.candidate}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  color: con?.colorCode,
                                  borderLeftColor: "#d2d1d1",
                                  borderLeftWidth: "0.2px",
                                  fontSize: "18px",
                                }}
                              >
                                <img
                                  src={con?.party_logo}
                                  width="25px"
                                  height="25px"
                                  style={{
                                    marginRight: "20px",
                                    borderRadius: "50%",
                                  }}
                                ></img>
                                {con?.party}
                              </td>
                              <td
                                className="winner-name"
                                style={{
                                  textAlign: "center",
                                  borderLeftColor: "#d2d1d1",
                                  borderLeftWidth: "0.2px",
                                  fontSize: "18px",
                                }}
                              >
                                {con?.votes}
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                </table>
              </div>
            </div>
          )}
        </div>
        {constituencyArray && constituencyArray?.length > 0 && (
          <div
            style={{
              margin: "1rem 0",
              backgroundColor: "#FFF",
              padding: "10px",
              borderRadius: "10px",
              // backgroundColor: "var(--bg-dark, #000)",
            }}
          >
            <div
              style={{
                color: "#333",
                fontWeight: "bold",
                fontSize: "1.125rem",
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
                minWidth: "28%",
              }}
            >
              <h2 style={{ color: "#D9368B" }}>
                {`${stateHindi} विधानसभा निर्वाचन क्षेत्र`}
              </h2>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                padding: "8px",
                border: "2px solid #E6E7E9",
                borderRadius: "20px",
              }}
            >
              {constituencyArray.map((item, index) => {
                return (
                  <a
                    key={index}
                    title={item?.cons_name}
                    href={`${process.env.NEXT_PUBLIC_BASE_URL}/election/${electionState
                      }/results/${item?.cons_name
                        .toLowerCase()
                        .replace(/[^a-zA-Z ]/g, "")
                        .split(" ")
                        .join("-")}-constituency-result/${item?.cons_id}`}
                    target="_self"
                  >
                    <div
                      key={index}
                      style={{
                        // backgroundColor:
                        //   item?.cons_id === constituencyId
                        //     ? "#F15C35"
                        //     : "#EEF3F7",
                        // color: item?.cons_id === constituencyId ? "#FFF" : "",
                        border: "2px solid #D2D1D1",
                        margin: "4px 0",
                        borderRadius: "20px",
                        padding: "8px 16px",
                        cursor: "pointer",
                      }}
                      className={item?.cons_id != constituencyId ? "election-box-ptag" : "election-box-ptag-active"}
                    >
                      <p style={{ margin: "0" }}>
                        {item?.cons_name_hi}
                      </p>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        )}
        <Container align="center">
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0px",
              }}
            >
              Advertisement
            </p>
            <div
              id={
                size.width > 600
                  ? "div-gpt-ad-1701945220410-1"
                  : "div-gpt-ad-1701946028239-1"
              }
              style={{
                minWidth: "300px",
                minHeight: size.width > 600 ? "100px" : "260px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center",
              }}
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html:
                    size.width > 600
                      ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})`
                      : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})`,
                }}
              ></script>
            </div>
          </div>{" "}
        </Container>
      </div>
    </>
  );
}

const ResponsiveCard = ({
  constituencyListData = [],
  constituencyArray = [],
  selectedConstituencyId = "",
  colorCode = "#000",
  constId = null,
  electionState
}) => {
  const router = useRouter();
  const [readMore, setReadMore] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [constList, setConstList] = useState([]);
  const [currentState, setCurrentState] = useState({});
  const [currentConst, setCurrentConst] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [prevData, setPrevData] = useState(constituencyArray);
  const website = "llt";
  const handleReadMoreClick = () => {
    setReadMore(!readMore);
  };
  console.log("current Obj ", constituencyArray);

  const [dropDownData, setDropdownData] = useState([]);

  useEffect(() => {
    let ar = [];
    constituencyArray.map((item) => {
      ar.push({
        label: `${item.cons_name_hi} (${item.cons_name})`,
        value: item.cons_id,
      });
    });
    setConstList(ar);
  }, []);

  useEffect(() => {
    let data = constList.filter((x) => x.value == constId);
    console.log("Current const", data);
    if (data.length > 0) {
      setCurrentConst(data[0]);
    }
  }, [constList]);

  useEffect(() => {
    if (
      isChanged &&
      currentConst !== null &&
      typeof currentConst !== "undefined"
    ) {
      const data = constituencyArray.filter(
        (item) => item?.cons_id === currentConst?.value
      );
      console.log("Both are ", data);
      window.open(
        `${`${process.env.NEXT_PUBLIC_BASE_URL}/election/${router.asPath.includes("jammu-kashmir") ? "jammu-kashmir" : "haryana"
        }-assembly-chunav/results/${data[0]?.cons_name
          .toLowerCase()
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .join("-")}-constituency-result/${data[0]?.cons_id}`}`,
        "_self"
      );
      window.open(
        `${`${process.env.NEXT_PUBLIC_BASE_URL}/election/${electionState
        }/results/${data[0]?.cons_name
          .toLowerCase()
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .join("-")}-constituency-result/${data[0]?.cons_id}`}`,
        "_self"
      );
    }
  }, [currentConst]);

  const fullText = `अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी बासास और काशी के नाम से भी जाना जाता है. इस हिस्टा में एक पतन नगर माना जाता है. ठंड और उमस के लिए भी एक महत्वपूर्ण शहर है...
  अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी बासास और काशी के नाम से भी जाना जाता है. इस हिस्टा में एक पतन नगर माना जाता है. ठंड और उमस के लिए भी एक महत्वपूर्ण शहर है
  अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी बासास और काशी के नाम से भी जाना जाता है. इस हिस्टा में एक पतन नगर माना जाता है. ठंड और उमस के लिए भी एक महत्वपूर्ण शहर है`;
  const previewText = `अगर प्रदेश का एक प्रमुख नगर और हिस्टा है वाराणसी...`;

  function findConstituency(value) {
    const query = value.toLowerCase();
    const prevData = constituencyArray;
    const newData = prevData.filter(
      (item) =>
        item.ac_name.toLowerCase().includes(query) ||
        item.name.toLowerCase().includes(query)
    );
    setPrevData(newData);
  }
  return (
    <div className="responsive-card shadow-sm">
      <br></br>
      <h5>Select Constituency</h5>
      {/* <Dropdown
        onChange={(e) => {
          setCurrentConst(e);
          // setIsChanged(true);
        }}
        options={constList}
        value={currentConst?.label}
        disabled={currentState ? false : true}
        placeholder="Select an option"
      />  */}
      {constList.length > 0 && (
        <SearchableDropdown
          options={constList}
          label="name"
          id="id"
          selectedVal={currentConst?.label}
          handleChange={(val) => {
            setCurrentConst(val);
            setIsChanged(true);
          }}
        />
      )}
    </div>
  );
};
